import { Controller, useFormContext } from "react-hook-form";
import { Button, Grid, Stack, TextField, MenuItem } from "@mui/material";

const unidadeDoseOptions = [
    { value: "GRA", label: "Gramas (GRA)" },
    { value: "HA", label: "Hectares (HA)" },
    { value: "KG", label: "Quilogramas (KG)" },
    { value: "L", label: "Litros (L)" },
    { value: "LT", label: "Litros (LT)" },
    { value: "ML", label: "Mililitros (ML)" },
    { value: "UN", label: "Unidades (UN)" },
];

const unidadeAreaOptions = [
    { value: "HA", label: "Hectares (HA)" },
    { value: "KG", label: "Quilogramas (KG)" },
    { value: "KGS", label: "Quilogramas (KGS)" },
    { value: "L", label: "Litros (L)" },
    { value: "LA", label: "Litros (LA)" },
    { value: "LT", label: "Litros (LT)" },
    { value: "mt2", label: "Metros quadrados (m²)" },
    { value: "mt3", label: "Metros cúbicos (m³)" },
    { value: "PL", label: "PL" },
    { value: "T", label: "Toneladas (T)" },
    { value: "UN", label: "Unidades (UN)" },
];

export default function Stepper02() {
    const { control, getValues, handleSubmit } = useFormContext();
    const handleNext = getValues("funcoesAux.onNext");

    const handleNextStep = () => {
        handleNext();
    };

    const handlePrevious = () => {
        const previousStep = getValues("funcoesAux.onBack");
        if (typeof previousStep === "function") previousStep();
    };

    return (
        <>
            <Grid container spacing={2} mb={1} alignItems='center'>
                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        name="quantidade_dose"
                        control={control}
                        rules={{ required: "Quantidade da dose é obrigatória" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                label="Qtd. dose"
                                type="number"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            />
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        name="unidade_dose"
                        control={control}
                        rules={{ required: "Unidade da dose é obrigatória" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                select
                                label="Unidade dose"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            >
                                <MenuItem value="">
                                    <em>Selecione</em>
                                </MenuItem>
                                {unidadeDoseOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        name="tamanho_area"
                        control={control}
                        rules={{ required: "Tamanho da área é obrigatório" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                label="Tamanho"
                                type="number"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            />
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <Controller
                        name="unidade_area"
                        control={control}
                        rules={{ required: "Unidade da área é obrigatória" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                select
                                label="Unidade área"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            >
                                <MenuItem value="">
                                    <em>Selecione</em>
                                </MenuItem>
                                {unidadeAreaOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Controller
                        name="quantidade_aplicacoes"
                        control={control}
                        rules={{ required: "Quantidade de aplicações é obrigatória" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                label="Qtd. aplicações"
                                type="number"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            />
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Controller
                        name="dias_intervalo_aplicacoes"
                        control={control}
                        rules={{ required: "Dias de intervalo entre aplicações é obrigatório" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                label="Dias intervalo aplicações"
                                type="number"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            />
                        )}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Controller
                        name="dias_carencia"
                        control={control}
                        rules={{ required: "Dias de carência é obrigatório" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                label="Dias carência"
                                type="number"
                                fullWidth
                                required
                                error={invalid}
                                helperText={error?.message}
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <Stack direction="row" justifyContent="flex-start" mt={2}>
                <Button variant="outlined" onClick={handlePrevious} sx={{ mr: 2 }}>
                    Voltar
                </Button>
                <Button variant="contained" onClick={handleSubmit(handleNextStep)}>
                    Avançar
                </Button>
            </Stack>
        </>
    );
}